import AppDoortypesIndex from "./doorType.vue";
import AppDoortypesList from "./list/list.vue";
import AppDoortypesItem from "./item/item.vue";

const routes = [
  {
    path: "/doortype",
    component: AppDoortypesIndex,
    meta: {
      auth: {
        roles: "doorType.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "doorType.index",
        component: AppDoortypesList,
        meta: {
          auth: {
            roles: "doorType.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "doorType.create",
        component: AppDoortypesItem,
        meta: {
          auth: {
            roles: "doorType.create",
            redirect: { name: "doorType.index" }
          }
        }
      },
      {
        path: ":id",
        name: "doorType.edit",
        component: AppDoortypesItem,
        meta: {
          auth: {
            roles: "doorType.update",
            redirect: { name: "doorType.index" }
          }
        }
      }
    ]
  }
];

export default routes;
